import { Button } from '@/components/ui/button'

interface FilterBarApplyProps {
  isDirty: boolean
  canReset: boolean
  onReset: () => void
  disabled?: boolean
}

export default function FilterBarApply({ isDirty, canReset, onReset, disabled }: FilterBarApplyProps) {
  return (
    <div className="flex shrink-0 items-center gap-2">
      <Button type="button" variant="ghost" onClick={onReset} disabled={disabled || !canReset}>
        Reset
      </Button>
      <Button type="submit" disabled={disabled || !isDirty}>
        Apply
      </Button>
    </div>
  )
}
